<template>
    <div v-if="isreadshow">
      <my-form readonly table>
          <my-form-item-group title="提示信息">
            <el-form-item  class="table-full-row">
                <div style="height:140px;line-height:140px;font-size:22px;">
                    {{errormsg}}
                </div>
            </el-form-item>
          </my-form-item-group>
      </my-form>
    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'
export default {
    mixins: [LIST_PAGE_MIXIN],
    data() {
        return{
            pgData:{
                txtkey:'',
                sortname : 'zbprocode',
                
            },
            isreadshow:true,
            tableData:[]
        }
    },
    props:['errormsg'],
    computed: {
        
    },
    watch: {

    },
    methods: {
       
    },
    created() {
        console.log(this.errormsg)
    },
    mounted() {
        
    }
}
</script>

<style scoped lang="scss">

</style>
